import { Badge, Button, Flex, Text } from '@radix-ui/themes'
import cn from 'classnames'
import { TetherAssetIcon } from 'shared/icons'
import { formatToTether } from 'shared/utils/format-price'
import type { WalletBalance } from '../types'
import styles from '../wallets.module.scss'

interface Props {
  address: string
  isPrimary: boolean
  isSelected: boolean
  isConnected: boolean
  balance?: WalletBalance
  onSelect: (address: string) => void
}

export const WalletListItem: React.FC<Props> = ({
  address,
  isPrimary,
  isSelected,
  isConnected,
  balance,
  onSelect
}) => {
  const totalBalance =
    balance ? balance.tokenBalance + balance.tokenDeposited : null

  return (
    <Flex
      direction='column'
      gap='2'
      className={cn(styles.walletItem, {
        [styles.walletItemSelected]: isSelected
      })}
    >
      <Flex
        gap='2'
        align='center'
        wrap='wrap'
      >
        <Text
          size='2'
          className={styles.walletAddress}
        >
          {address}
        </Text>
        {isPrimary && <Badge color='yellow'>Primary</Badge>}
        {isConnected && <Badge color='green'>Connected</Badge>}
      </Flex>

      <Flex
        justify='between'
        align='center'
        gap='2'
      >
        <Flex
          align='center'
          gap='1'
        >
          <TetherAssetIcon />
          <Text size='2'>
            {totalBalance === null ?
              '—'
            : `${formatToTether(Math.trunc(totalBalance * 100) / 100)} USDT`}
          </Text>
        </Flex>

        {isSelected ?
          <Badge
            color='yellow'
            variant='outline'
          >
            Selected for play
          </Badge>
        : <Button
            size='1'
            variant='soft'
            onClick={() => onSelect(address)}
          >
            Play with this wallet
          </Button>
        }
      </Flex>
    </Flex>
  )
}
